import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {PasswordValidators} from "./password-validator";

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {

    resetPasswordForm: any;
    isPassInvalid: boolean = true;
    showResPassError = false;
    @Input() cveUser = ""
    @Input() showCurrentPassword = false
    @Input() isModal = false
    validationRules = [
        {key: 'invalidLength', translation: 'resetPasswordRecommendation1'},
        {key: 'noSpecialChar', translation: 'resetPasswordRecommendation2'},
        {key: 'ascDescChars', translation: 'resetPasswordRecommendation3'},
        {key: 'consecutiveChars', translation: 'resetPasswordRecommendation4'},
        {key: 'containsMonex', translation: 'resetPasswordRecommendation5'},
        {key: 'containsUsername', translation: 'resetPasswordRecommendation6'},
        {key: 'noNumber', translation: 'resetPasswordRecommendation8'},
        {key: 'noUppercase', translation: 'resetPasswordRecommendation7'},
    ];

    @Output() changePasswordEmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(private formBuilder: FormBuilder,) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    ngAfterViewInit() {
    }

    getClassesForPasswordInput() {
        return `p-password-custom ${this.resetPasswordForm && this.resetPasswordForm.get('password').invalid && this.resetPasswordForm.controls['password']?.touched ? 'p-password-error' : ''}`
    }


    buildForm() {
        this.resetPasswordForm = this.formBuilder.group({
            currentPassword: [''],
            password: ['',
                [
                    Validators.required,
                    PasswordValidators.validateLength(),
                    PasswordValidators.hasSpecialCharacters(),
                    PasswordValidators.hasAscDescCharacters(),
                    PasswordValidators.hasConsecutiveCharacters(),
                    PasswordValidators.hasMonexWord(),
                    PasswordValidators.hasNumber(),
                    PasswordValidators.hasUppercaseCharacter(),
                    PasswordValidators.hasUsernameCode(this.cveUser)
                ]
            ],
            confirmPassword: ['',
                [
                    Validators.required,
                    PasswordValidators.matchConfirmPassword(this.resetPasswordForm?.get('password')?.value)
                ]
            ],
        });

        if (this.showCurrentPassword) {
            this.resetPasswordForm.controls.currentPassword.setValidators([Validators.required]);
        }
        this.resetPasswordForm.get('password')?.valueChanges.subscribe(password => {
            this.resetPasswordForm.get('confirmPassword')?.setValidators([
                Validators.required,
                PasswordValidators.matchConfirmPassword(password)
            ]);
            this.resetPasswordForm.get('confirmPassword')?.updateValueAndValidity();
        });
    }


    isValidPassword(validator) {
        return !this.resetPasswordForm.get('password').hasError(validator);
    }

    formIsTouched() {
        return this.resetPasswordForm.get('password').touched;
    }


    savePassword(): void {
        this.changePasswordEmit.emit(this.resetPasswordForm.getRawValue());
    }
}
